import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Tecnica } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Tecnica>()

export function TableTecniche({
  tecniche,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  tecniche: Tecnica[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!tecniche) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [tecniche, count])

  return (
    <Table
      data={tecniche}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(tecnica) => (
          <Link to={`/tecniche-immagini/tecniche-immagini/${tecnica.id}`}>
            <LinkMagik className="text-dark">{tecnica.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} tecniche
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>

    </Table>
  )
}
